/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import has from 'lodash/has';
import isNil from 'lodash/isNil';
import isObject from 'lodash/isObject';

import ErrorLevel from '../error/error-level';

// TODO: Proč je to továrna, když se fromValue nikde nepoužívá a tak to neprodukuje žádné nové objekty?
/**
 * Továrna na úrovně obecných chyb.
 */
class ErrorLevelFactory {
  /** Vytvoří instanci. */
  constructor() {
    this.priorityMap = new Map(
      ['Debug', 'Log', 'Info', 'Warning', 'Error'].map((key, index) => [
        ErrorLevel[key],
        index
      ])
    );
  }

  /**
   * Porovná dvě úrovně chyb.
   * @param {ErrorLevel} first
   * @param {ErrorLevel} second
   * @returns {number} Číslo -1, 0, 1 dle konvencí z `Array.sort`.
   */
  compare(first, second) {
    const firstPriority = this.priorityMap.get(first);
    if (isNil(firstPriority)) {
      throw new RangeError(`Unknown error level "${first}".`);
    }
    const secondPriority = this.priorityMap.get(second);
    if (isNil(secondPriority)) {
      throw new RangeError(`Unknown error level "${second}".`);
    }
    if (firstPriority < secondPriority) {
      return -1;
    }
    if (firstPriority > secondPriority) {
      return 1;
    }
    return 0;
  }

  /**
   * Identifikuje úroveň chyby z libovolné hodnoty.
   * Používá se k tomu speciální klíč `level`,
   * který lze nastavit libovolnému objektu.
   * @param {*} value
   * @private
   * @returns {ErrorLevel|null} Identifikovaná úroveň, nebo `null`,
   * pokud žádná nebyla nalezena.
   */
  fromValue(value) {
    // Pokud není hodnota objektem, tak se použije úroveň chyby dle metody.
    if (!isObject(value)) {
      return null;
    }
    // Z objektu lze načíst specifickou hodnotu "level".
    const valueLevel = value.level;
    // Pokud není definovaná, nebo není v číselníku,
    // tak se použije úroveň chyby dle metody.
    if (isNil(valueLevel) || !this.isErrorLevel(valueLevel)) {
      return null;
    }
    // Pokud se v logované hodnotě podařila nalézt úroveň, tak se použije.
    return valueLevel;
  }

  /**
   * Určí, jestli je hodnota platnou úrovní chyby.
   * @param {*} value
   * @returns {boolean}
   */
  isErrorLevel(value) {
    return has(ErrorLevel, value);
  }
}

export default ErrorLevelFactory;
